import { IApiClient } from "../api-client";
import { EnvType } from "../services";
import { FormDataZendeskTicketRequest } from "../Types/form-data-ticket-zendesk-request";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetFormFieldsResponse } from "../Types/get-form-fields-response";
import { GetIsAlreadyReportedResponse } from "../Types/get-issue-already-reported-response";
import { GetTokenRequest } from "../Types/get-token-request";
import { GetTokenResponse } from "../Types/get-token-response";

interface ISupportApiClient {
  CreateZendeskIssue(request: FormDataZendeskTicketRequest, file: File | undefined): Promise<GenericResponseStd>;
  GenerateZendeskToken(request: GetTokenRequest): Promise<GetTokenResponse>;
  GetZendeskFormFields(): Promise<GetFormFieldsResponse>;
  GetIssueAlreadyReported(typology: string, objectId: number): Promise<GetIsAlreadyReportedResponse>;
}

export default class SupportApiClient implements ISupportApiClient {
  readonly servicePort = 9512;
  readonly serviceBaseUrl = "support-service/api";

  supportApiClient: IApiClient;

  constructor(supportApiClient: IApiClient, envType: EnvType) {
    this.supportApiClient = supportApiClient;
    if (envType === "local") this.supportApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async CreateZendeskIssue(request: FormDataZendeskTicketRequest, file: File | undefined): Promise<GenericResponseStd> {
    const formData = new FormData();
    formData.append("subject", String(request.subject));
    formData.append("description", String(request.description));
    formData.append("techInfos", String(request.techInfos));
    formData.append("typology", String(request.typology));
    formData.append("subTypology", String(request.subTypology));
    formData.append("objectId", String(request.objectId));
    formData.append("priority", String(request.priority));
    if (request.followers) {
      request.followers.forEach((follower) => {
        formData.append("followers[]", follower);
      });
    }
    if (file) formData.append("file", file);

    return await this.supportApiClient.postUploadFormData(`${this.serviceBaseUrl}/zendesk/issues`, formData);
  }
  async GenerateZendeskToken(request: GetTokenRequest): Promise<GetTokenResponse> {
    return await this.supportApiClient.post(`${this.serviceBaseUrl}/zendesk/token`, request);
  }
  async GetZendeskFormFields(): Promise<GetFormFieldsResponse> {
    return await this.supportApiClient.get(`${this.serviceBaseUrl}/zendesk/form-fields`);
  }
  async GetIssueAlreadyReported(typology: string, objectId: number): Promise<GetIsAlreadyReportedResponse> {
    return await this.supportApiClient.get(`${this.serviceBaseUrl}/zendesk/issue/${typology}/${objectId}`);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.supportApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
